import PropTypes from 'prop-types';

const LoadingCircle = ({ height, width }) => (
  <span
    className="animate-loading rounded-full bg-gray-2 bg-loading bg-no-repeat inline-block leading-none"
    style={{ height, width, backgroundSize: '200px 100%' }}
  >
    &zwnj;
  </span>
);

LoadingCircle.defaultProps = {
  height: 24,
  width: 24,
};

LoadingCircle.propTypes = {
  /**
   * The height the circle will be set to, either a number or string value such as "3rem".
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The width the circle will be set to, either a number or string value such as "3rem".
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default LoadingCircle;
